export { default as createPlugin } from './createPlugin'
export { getPluginConfig, getPlugin, getPlugins } from './config'
